export const getErrorMessageTitle = (userNotFound: boolean, isAccessDenied: boolean, error: string) =>
	userNotFound
		? 'Incorrect username or password'
		: isAccessDenied
		? 'You don’t have access to view this resource'
		: error;
